import { useRef } from "react";

export default function useCache<T>(): BasicCache<T> {
    const data = useRef<{ [key: string]: T }>({});

    function get(key: string): T {
        return data.current[key];
    }

    function set(key: string, value: T): void {
        data.current = { ...data.current, [key]: value }
    }

    return {
        get,
        set
    }
}

interface BasicCache<T> {
    get(key: string): T;
    set(key: string, value: T): void;
}